import Vue from 'vue'
import App from './App.vue'
import VueSweetalert2 from 'vue-sweetalert2';

Vue.config.productionTip = false
import 'sweetalert2/dist/sweetalert2.min.css';
import * as firebase from "firebase/app";

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";
const firebaseConfig = {
  apiKey: "AIzaSyBNU0w6mR_Zc8Gvd9prSUrvupCJtlgYUyg",
  authDomain: "recycling-game.firebaseapp.com",
  databaseURL: "https://recycling-game.firebaseio.com",
  projectId: "recycling-game",
  storageBucket: "recycling-game.appspot.com",
  messagingSenderId: "320162336568",
  appId: "1:320162336568:web:8309dfe7dda4e94292fbcd",
  measurementId: "G-M73F25S502"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

Vue.use(VueSweetalert2);
new Vue({
  render: h => h(App),
}).$mount('#app')
